import React, { useState, useEffect } from "react";
import { AppBar, Typography, Container, IconButton, Box, Tooltip } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';

import { styled } from '@mui/material/styles';
import Badge, { badgeClasses } from '@mui/material/Badge';

import ThemeToggleButton from "./SubComponents/ThemeToggleButton";
import NotificationsIcon from '@mui/icons-material/Notifications';

const CartBadge = styled(Badge)`
  & .${badgeClasses.badge} {
    top: 2px;
    right: -4px;
    background-color: red;
    color: white;
    font-weight: bold;
  }
`;

const NotificationButton = ({ count, onClick, display }) => (
  <Tooltip title="Abrir notificaciones">
    <IconButton
      sx={{ color: 'white', display, '&:focus-visible': { outline: '3px solid currentColor' } }}
      onClick={onClick}
      aria-label={`Abrir notificaciones. ${count} pendientes`}
    >
      <CartBadge badgeContent={count} max={99} overlap="circular">
        <NotificationsIcon sx={{ color: 'white' }} fontSize="medium" />
      </CartBadge>
    </IconButton>
  </Tooltip>
);

const BottomBar = ({ handleClickOpenDialogMensualidades, notificationCount }) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <>
      <AppBar position="static" sx={{ top: "auto", bottom: 0 }}>
        <Container maxWidth='100%' sx={{ display: "flex", flexGrow: 1 }}>
          <Grid container spacing={3} width='100%'>
            <Grid size="grow" />
            <Grid
              sx={{
                display: "flex",
                flex: 1,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  height: '90%',
                  paddingLeft: 3,
                  paddingRight: 3,
                  paddingTop: 1,
                  paddingBottom: 1,
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "rgba(0,0,0,0.3)",
                }}
              >
                <Typography variant="h4">{currentTime.toLocaleTimeString('sv-SE', { hour12: false, timeZone: 'America/Bogota' })}</Typography>
                <Typography variant="h6" sx={{ ml: 2, paddingRight: 2 }}>
                  {currentTime.toLocaleDateString('sv-SE', { timeZone: 'America/Bogota' })}
                </Typography>
                <ThemeToggleButton />

                <NotificationButton count={notificationCount} onClick={handleClickOpenDialogMensualidades} display={{ xs: 'flex', md: 'none' }} />
              </Box>
            </Grid>
            <Grid size="grow">
              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  height: '100%',
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <NotificationButton count={notificationCount} onClick={handleClickOpenDialogMensualidades} display={{ xs: 'none', md: 'flex' }} />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </AppBar>
    </>
  );
};

export default BottomBar;
